import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import DynamicInputField from './DynamicInputField';

const DynamicForm = ({ formClass, fields, onSubmit, onError, onClose, defaultValues = {}, disabledFields=[] }) => {
    const { handleSubmit, control, formState: { errors, isSubmitting }, setValue, getValues, watch, reset } = useForm({ defaultValues });
    useEffect(() => {
        if (defaultValues && Object.keys(defaultValues).length > 0) {
            reset(defaultValues);
          }
    }, [defaultValues, reset]);
    const watchedValues = watch();
    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} noValidate>
            <div className={formClass || "d-flex flex-column gap-3"}>
                {fields.filter(field => !field.visibleIf || field.visibleIf(watchedValues)).map((field, index) => (
                    <DynamicInputField
                        key={index}
                        fieldConfig={field}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        getValues={getValues}
                        isDisabled={isSubmitting || disabledFields.includes(field.name) || (field.disabledIf ? field.disabledIf(watchedValues) : false)}
                    />
                ))}
            </div>

            <div className="d-flex justify-content-end mt-4">
                <button className="btn light_primary_btn me-3" type="button" onClick={onClose} disabled={isSubmitting}>
                    Cancel
                </button>
                <button type="submit" className="btn primary_btn btn-loader" disabled={isSubmitting}>
                    {isSubmitting ? 'Saving...' : 'Save'}
                </button>
            </div>
        </form>
    );
};

export default DynamicForm;
